import { Tab, Tabs } from '@mui/material'
import { type FC } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom'
import { recruiterRouteConfig } from 'recruiter/routes'

type ContextTab = 'on' | 'all'

const TAB_CONFIG: Array<{ value: ContextTab; label: string }> = [
    { value: 'on', label: 'On These Searches' },
    { value: 'all', label: 'All Searches' },
]

export const CandidateRosterContextTabs: FC = () => {
    const { candidateId } = useParams<{ candidateId: string }>()
    const location = useLocation()

    const activeTab: ContextTab = location.pathname.endsWith('/all')
        ? 'all'
        : 'on'

    const buildPath = (tab: ContextTab) => {
        const basePath = `${recruiterRouteConfig.candidates.path}/${candidateId}/overview/${tab}`
        return location.search ? `${basePath}${location.search}` : basePath
    }

    return (
        <Tabs
            value={activeTab}
            sx={{
                minHeight: 0,
                '& .MuiTab-root': {
                    minHeight: 0,
                    py: 0.5,
                    px: 1.5,
                    fontSize: '0.75rem',
                    textTransform: 'none',
                },
                '& .MuiTabs-indicator': {
                    height: 2,
                },
            }}
        >
            {TAB_CONFIG.map(({ value, label }) => (
                <Tab
                    key={value}
                    value={value}
                    label={label}
                    component={Link}
                    to={buildPath(value)}
                />
            ))}
        </Tabs>
    )
}
